import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const HintEditorContext = createContext({
  activeWorkspace: 'python',
  editorCode: '',
  simulatorCode: '',
  simulatorState: '',
  setActiveWorkspace: () => {},
  setEditorCode: () => {},
  setSimulatorCode: () => {},
  setSimulatorState: () => {},
});

export function HintEditorProvider({ children }) {
  const [activeWorkspace, setActiveWorkspaceState] = useState('python');
  const [editorCode, setEditorCodeState] = useState('');
  const [simulatorCode, setSimulatorCodeState] = useState('');
  const [simulatorState, setSimulatorStateState] = useState('');

  const setActiveWorkspace = useCallback((next) => {
    setActiveWorkspaceState(next === 'simulator' ? 'simulator' : 'python');
  }, []);

  const setEditorCode = useCallback((next) => {
    setEditorCodeState(typeof next === 'string' ? next : '');
  }, []);

  const setSimulatorCode = useCallback((next) => {
    setSimulatorCodeState(typeof next === 'string' ? next : '');
  }, []);

  const setSimulatorState = useCallback((next) => {
    setSimulatorStateState(typeof next === 'string' ? next : '');
  }, []);

  const value = useMemo(
    () => ({
      activeWorkspace,
      editorCode,
      simulatorCode,
      simulatorState,
      setActiveWorkspace,
      setEditorCode,
      setSimulatorCode,
      setSimulatorState,
    }),
    [
      activeWorkspace,
      editorCode,
      simulatorCode,
      simulatorState,
      setActiveWorkspace,
      setEditorCode,
      setSimulatorCode,
      setSimulatorState,
    ]
  );

  return (
    <HintEditorContext.Provider value={value}>
      {children}
    </HintEditorContext.Provider>
  );
}

export function useHintEditor() {
  return useContext(HintEditorContext);
}
